/** Shared phone-case filter taxonomy (must match backend seed / product fields). */

export const PHONE_CASE_CATEGORY = 'Phone Cases';

export const CASE_TYPES = ['Clear', 'Silicone', 'MagSafe', 'Rugged', 'Leather'];

export const DEVICES = [
  'iPhone 15',
  'iPhone 14',
  'iPhone 13',
  'Galaxy S24',
  'Galaxy S23',
  'OnePlus 12',
  'Pixel 8',
];

export const CASE_BRANDS = ['Spigen', 'OtterBox', 'Ringke', 'Casetify', 'Apple'];

export const CASE_COLORS = ['Black', 'Clear', 'Blue', 'Red', 'Purple'];

/** Single-select price buckets for mobile filters (min/max inclusive for API). */
export const PRICE_RANGES = [
  { id: '0-500', label: '₹0 – ₹500', min: 0, max: 500 },
  { id: '500-750', label: '₹500 – ₹750', min: 500, max: 750 },
  { id: '750-1000', label: '₹750 – ₹1,000', min: 750, max: 1000 },
  { id: '1000-1500', label: '₹1,000 – ₹1,500', min: 1000, max: 1500 },
  { id: '1500-2000', label: '₹1,500 – ₹2,000', min: 1500, max: 2000 },
  { id: '2000-3000', label: '₹2,000 – ₹3,000', min: 2000, max: 3000 },
  { id: '3000-5000', label: '₹3,000 – ₹5,000', min: 3000, max: 5000 },
  { id: '5000-10000', label: '₹5,000 – ₹10,000', min: 5000, max: 10000 },
];

export function toSelectedMap(values, selected = []) {
  const selectedSet = new Set((selected || []).map((v) => String(v)));
  return Object.fromEntries(values.map((v) => [v, selectedSet.has(v)]));
}

export function keysFromSelectedMap(map) {
  return Object.keys(map || {}).filter((key) => map[key]);
}

export function matchParamToKeys(param, keys) {
  if (!param) return [];
  const lower = String(param).toLowerCase();
  return keys.filter((key) => key.toLowerCase() === lower);
}

export const DEFAULT_QUERY_PARAMS = {
  category: [],
  subcategory: [],
  caseType: [],
  brand: [],
  color: [],
  price: [0, 10000],
};

export function buildPhoneCaseQueryParams({
  caseType = [],
  subcategory = [],
  brand = [],
  color = [],
  price = DEFAULT_QUERY_PARAMS.price,
  sort,
} = {}) {
  const nextCaseType = Array.isArray(caseType) ? caseType.filter(Boolean) : [];
  const nextSubcategory = Array.isArray(subcategory) ? subcategory.filter(Boolean) : [];
  const nextBrand = Array.isArray(brand) ? brand.filter(Boolean) : [];
  const nextColor = Array.isArray(color) ? color.filter(Boolean) : [];
  const hasFacet =
    nextCaseType.length > 0 ||
    nextSubcategory.length > 0 ||
    nextBrand.length > 0 ||
    nextColor.length > 0;

  const params = {
    category: hasFacet ? [PHONE_CASE_CATEGORY] : [],
    subcategory: nextSubcategory,
    caseType: nextCaseType,
    brand: nextBrand,
    color: nextColor,
    price: Array.isArray(price) && price.length === 2 ? [Number(price[0]) || 0, Number(price[1]) || 10000] : [...DEFAULT_QUERY_PARAMS.price],
  };

  if (sort && sort !== 'popularity' && sort !== 'recommended') {
    params.sort = sort;
  }

  return params;
}

export function hasPhoneCaseFilters(queryParams = {}) {
  return (
    (Array.isArray(queryParams.category) && queryParams.category.length > 0) ||
    (Array.isArray(queryParams.subcategory) && queryParams.subcategory.length > 0) ||
    (Array.isArray(queryParams.caseType) && queryParams.caseType.length > 0) ||
    (Array.isArray(queryParams.brand) && queryParams.brand.length > 0) ||
    (Array.isArray(queryParams.color) && queryParams.color.length > 0) ||
    (Array.isArray(queryParams.price) &&
      (Number(queryParams.price?.[0]) > 0 || Number(queryParams.price?.[1]) < 10000))
  );
}

export const SEARCH_SUGGESTIONS = [
  'iPhone 15 cases',
  'iPhone 14 MagSafe',
  'Galaxy S24 case',
  'Clear case',
  'Silicone case',
  'Spigen',
  'OtterBox',
  'Rugged case',
  'Pixel 8 case',
  'OnePlus 12 case',
];
